module.exports = __webpack_public_path__ + "media/images/athletes/1580-c633d152ca0a298762352b61b4b3a07b.png";